// Process-stable detection of third-party iframe embed mode.
//
// `chat.zenvoya.ai` runs inside the same-origin `zenvoya.ai` marketing iframe
// in production via the `#app_domain` channel. That same-origin path must NOT
// trigger embed-mode behavior (postMessage resize, partner-origin SSO accept).
//
// Embed mode is opted into explicitly by the partner-facing loader script
// (`public/embed.js`) appending `?embed=1` to the iframe URL. The loader is
// the only caller that sets this flag.

let cached: boolean | null = null;

const EMBED_FLAG_KEY = "_zenvoya_embed_mode";

export function isEmbedMode(): boolean {
  if (cached !== null) return cached;
  if (typeof window === "undefined") {
    cached = false;
    return cached;
  }
  try {
    const value = new URLSearchParams(window.location.search).get("embed");
    const fromUrl = value === "1" || value === "true";
    if (fromUrl) {
      cached = true;
      try {
        window.sessionStorage.setItem(EMBED_FLAG_KEY, "1");
      } catch {
      }
      return cached;
    }
    cached = window.sessionStorage.getItem(EMBED_FLAG_KEY) === "1";
  } catch {
    cached = false;
  }
  return cached;
}

export function consumerLoginPromptAllowed(): boolean {
  return !isEmbedMode();
}

// Allowlist of partner origins permitted to send the existing same-origin SSO
// payload (`{ id, loggedIn, jwt }`) to AppRoutes.tsx's window-message listener.
//
//
const parseOrigins = (raw?: string): readonly string[] =>
  String(raw || "")
    .split(",")
    .map((o) => o.trim().replace(/\/+$/, ""))
    .filter(Boolean);

export const PARTNER_ORIGIN_ALLOWLIST: readonly string[] = parseOrigins(process.env.REACT_APP_PORTAL_ORIGINS);

export function isAllowedPartnerOrigin(origin: string): boolean {
  return PARTNER_ORIGIN_ALLOWLIST.includes(String(origin || "").replace(/\/+$/, ""));
}
